// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/sbg-dynamic-share-price-historical/sbg-dynamic-share-price-historical.component.scss
// module id = 722
// module chunks = 0